import { Action } from '@ngrx/store';
import { ActionOptionsArgs, SynchronisableAction } from '../../../core/store/actions/base-actions';
import { CategoryGroup } from './category-group.model';

export const ENTITY = 'categoryGroup';
export const SUBMIT = '[CategoryGroup] Submit';
export const REHYDRATE = '[CategoryGroup] Rehydrate';
export const REMOVE = '[CategoryGroup] Remove';

export class SubmitAction extends SynchronisableAction {
    readonly entity = ENTITY;
    readonly type = SUBMIT;

    constructor(public payload: CategoryGroup, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:entity:${this.payload.id}`;
    }
}

export class RehydrateAction implements Action {
    readonly entity = ENTITY;
    readonly type = REHYDRATE;

    constructor(public payload: Array<CategoryGroup>) {

    }
}

export class RemoveAction extends SynchronisableAction {
    readonly entity = ENTITY;
    readonly type = REMOVE;

    constructor(public payload: CategoryGroup, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:entity:${this.payload.id}`;
    }
}

export type Actions
    = SubmitAction
    | RehydrateAction
    | RemoveAction;



// WEBPACK FOOTER //
// ./src/vas/business-objects/category-group/category-group.actions.ts